import React from 'react';
import Banner_1 from '../assets/banner_2.jpeg'

const AhlalBayt = () => {

  return (
    <div className='container karbala'>
    <div className="page-head mt-5">

        <div className="text-box">
            <h2>Əhli Beyt</h2>
            <img src="https://images-ext-1.discordapp.net/external/ts83RH1RF6UM3llbymxhY3t5O6cVVPfoqgmstLClOMw/https/www.alawy.net/upload/2393.jpg?width=728&height=473" alt="" />
        </div>
    </div>

    <div className="main-part">
  <h3>Əhli-Beyt əleyhissəlamın haqqında.</h3>
<p>
Allah rəsulu (s.ə.v) buyurub ki:
"Hər şeyin bir təməli vardır, İslamın təməli isə biz Əhli-Beyti sevməkdir",‘Əhl’ sözü izafət kimi ‘Əhlü’l Kura’ (şəhər xalqı) və ya ‘Əhlü’l Kitab’ (kitaba bağlı olanlar və ya onu oxuyanlar) ərəb söz birləşmələrində, ‘Beyt’ sözü isə ərəbcə ‘ev’ mənasında işlənir. ‘Əhl-i Beyt’ anlayışı ‘birinin yaxınlarını və soydaşlarını’ ifadə edir. Quran-i Kərim’də Hz. İbrahim’in övladlarına və övladlarının övladlarına münasibətdə ‘Əhl-i Beyt’ anlayışı işlənmişdir: ‘Ey ev əhli! Allah’ın bərəkəti və mərhəməti üstünüzdə olsun!’ (Hud, 73). Müsəlmanlar arasında ‘Əhl-i Beyt’ anlayışı mənbələrə əsasən Rəsulullah’ın övladları ilə əlaqədar istifadə olunmuşdur. Kitab və sünnətdə ‘Əhl-i Beyt’ anlayışının xüsusi bir mənası vardır. ‘Əhl-i Beyt’ dedikdə, Rəsulullah’ın (s.ə.v) qızı Fatimə (ə.s), nəvələri Həsən (ə.s) və Hüseyn (ə.s), kürəkəni İmam Əli (ə.s) nəzərdə tutulur. Təthir ayəsi onlar ilə əlaqədar enmişdir: ‘Ey Əhli-Beyt! Allah sizdən çirkinliyi (günahı) yox etmək və sizi tərtəmiz (pak) etmək istər!’(Əhzab, 33). ‘Əhl-i Beyt’ anlayışındakı ‘ev’ sözü adi bir evi deyil, peyğəmbərlik ilə bağlı olan evi ifadə edir. Yəni ‘Əhl-i Beyt’ Peyğəmbərin (s.ə.v) evində təlim-tərbiyə alan, böyük və kiçiyin yerini bilən, əşyanın həqiqətini anlayan, geniş elmi və yəqinliyi olan Hz. Əli (ə.s), Hz. Fatimə (ə.s), Hz. Həsən (ə.s) və Hz. Hüseyn’ə (ə.s) aiddir. Quran-i Kərim’də bir çox ayədən və Rəsulullah’ın (s.ə.v) yüz­lərlə hədisindən məlumdur ki, ‘Əhl-i Beyt’ yalnız Hz. Fatimə (ə.s), Hz. Əli (ə.s), Hz. Həsən (ə.s), Hz. Hüseyn (ə.s) və Rəsulullah’dan (s.ə.v) ibarətdir. Ancaq bəzi əsərlərdə ‘Əhl-i Beyt’ adı altında Rəsulullah’ın (s.ə.v) həyat yoldaşlarının və hətta Haşimoğullarının da olduğunu iddia edən müəlliflər vardır:
</p>
<p>1.Nişaburi, Muqatil, Suyuti kimi bəzi alimlər təthir ayəsində Hz. Peyğəmbərin (s.ə.v) xanımlarının da yer aldığını iddia edirlər.</p>




<p>2.Abdullah b. Abbas və İqrimə kimi müəlliflər isə ‘Əhl-i Beyt’ adı altında yalnız Rəsulullah’ın (s.ə.v) müba­rək həyat yoldaşlarının olduğunu iddia edirlər.</p>




<p>3.Bir qrup alimlər də ‘Əhl-i Beyt’ə Haşimoğullarının aid olduğunu iddia etmiş və hətta onlardan bəziləri anlayışın həcmini daha da genişləndirərək ona Rəsulullah’ın (s.ə.v) həyat yoldaşlarını, kölə və cariyələrini, bütün qadın-kişi qohumlarını, Rəsulullah’a (s.ə.v.) xidmət edənləri, O’nu sona qədər təqib edən hər kəsi aid etmişlər.”</p>
    </div>
</div>

  )
}

export default AhlalBayt;